import { Box, Paper } from "@mui/material";
import { IconUsers } from "@tabler/icons-react";
import { GAME_STATUS } from "../../constants/game";
import { formatTeamSize, getMaxPlayersFromTeamSize } from "../../utils/game";
import Text from "../ui/Text";

const GameCard = ({ game }) => {
  const time = new Date(game.datetime).toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
  });
  const description = `${formatTeamSize(game.players)} ${game.sport} with ${game.creator_name}`;
  const currentPlayers = game?.active_players?.length || 0;
  const maxPlayers = getMaxPlayersFromTeamSize(game.players);
  const isCancelled = game.status === GAME_STATUS.CANCELLED;

  return (
    <Paper
      sx={{
        p: 1,
        boxShadow: "none",
        border: "1px solid #3b3b3b20",
        borderRadius: "8px",
        "&:hover": {
          cursor: "pointer",
          backgroundColor: "#fBfBfB",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 1,
        }}
      >
        <Text variant="subtitle2">{game.venue}</Text>
        <Text variant="subtitle2">{time}</Text>
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Text variant="paragraph2" sx={{ color: "#525252" }}>
          {description}
        </Text>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 0.5,
          }}
        >
          {isCancelled ? (
            <>
              <Text
                variant="paragraph2"
                sx={{
                  color: "#FB2C36",
                  height: "20px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                Cancelled
              </Text>
            </>
          ) : (
            <>
              <IconUsers size={16} color="#525252" />
              <Text variant="paragraph2" sx={{ color: "#525252" }}>
                {currentPlayers}/{maxPlayers}
              </Text>
            </>
          )}
        </Box>
      </Box>
    </Paper>
  );
};

export default GameCard;
